<template>
	<div class="station">
		<div>
			<h2 class="station__title">Station {{ station.name }}</h2>

			<p v-if="stopped" class="station__subtitle">Gestopt op {{ stopped.format('DD-MM-YYYY') }}</p>
			<p v-else-if="started" class="station__subtitle">Gestart op {{ started.format('DD-MM-YYYY') }}</p>
			<p v-else class="station__subtitle">Nog niet gestart</p>
		</div>
		<button class="button station__start-button" v-on:click.prevent="select()">Start station</button>
	</div>
</template>

<script>
import moment from 'moment';

export default {
	name: 'Station',
	props: {
		station: Object,
	},
	computed: {
		state() {
			return this.$actions.getClassState(this.station.uuid);
		},
		stopped() {
			return this.getStateTimestamp('stop');
		},
		started() {
			return this.getStateTimestamp('start');
		},
	},
	methods: {
		select() {
			this.$emit('select');
		},
		getStateTimestamp(state) {
			if (!this.state) {
				return null;
			}

			const timestamp = this.state[state];

			if (!timestamp) {
				return null;
			}

			return moment(timestamp * 1000);
		},
	},
};
</script>

<style scoped></style>
